import React from 'react';

const About = () => {
  return (
    <div className="about-page">
      <div className="hero-section">
        <h1>About HotSide Repairs</h1>
        <p className="subtitle">Your Trusted Partner in Commercial Kitchen Equipment Repairs</p>
      </div>

      <div className="content-section">
        <div className="mission-section card">
          <h2>Our Mission</h2>
          <p>
            At HotSide Repairs, we're dedicated to keeping commercial kitchens running smoothly by connecting businesses with expert repair services. Our platform brings together the most qualified and reliable repair professionals, ensuring minimal downtime for your kitchen operations.
          </p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">500+</div>
            <div className="stat-label">Service Providers</div>
            <p>Verified and certified repair professionals across the country</p>
          </div>
          <div className="stat-card">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Support</div>
            <p>Round-the-clock emergency repair services available</p>
          </div>
          <div className="stat-card">
            <div className="stat-number">50+</div>
            <div className="stat-label">Cities</div>
            <p>Serving major metropolitan areas nationwide</p>
          </div>
        </div>

        <div className="features-section">
          <h2>Why Choose Us</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🛠️</div>
              <h3>Expert Technicians</h3>
              <p>All service providers are thoroughly vetted and certified in commercial kitchen equipment repair</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Fast Response</h3>
              <p>Quick connection with qualified repair services in your area</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Competitive Pricing</h3>
              <p>Compare quotes from multiple providers to find the best value</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">✓</div>
              <h3>Quality Guaranteed</h3>
              <p>All repairs backed by our satisfaction guarantee</p>
            </div>
          </div>
        </div>

        <div className="commitment-section card">
          <h2>Our Commitment</h2>
          <p>
            We understand that a functioning kitchen is crucial to your business. That's why we're committed to providing fast, reliable repair services through our network of skilled technicians. Our platform is designed to minimize downtime and ensure your kitchen equipment stays in optimal condition.
          </p>
        </div>
      </div>

      <style>
        {`
          .about-page {
            min-height: 100vh;
            background: linear-gradient(145deg, #1a1a1a, #000);
            color: #fff;
          }

          .hero-section {
            padding: 6rem 2rem;
            text-align: center;
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-bottom: 4px solid #ff6b35;
            position: relative;
          }

          .hero-section h1 {
            font-size: 3.5rem;
            font-weight: 800;
            margin-bottom: 1.5rem;
            text-transform: uppercase;
            letter-spacing: 2px;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
          }

          .subtitle {
            font-size: 1.5rem;
            color: rgba(255,255,255,0.9);
            max-width: 800px;
            margin: 0 auto;
            font-weight: 300;
          }

          .content-section {
            max-width: 1200px;
            margin: 0 auto;
            padding: 4rem 2rem;
          }

          .card {
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-radius: 12px;
            padding: 2rem;
            margin-bottom: 3rem;
            box-shadow: 0 8px 24px rgba(0,0,0,0.3);
            border: 2px solid rgba(255,255,255,0.1);
          }

          h2 {
            font-size: 2.5rem;
            color: #ff6b35;
            margin-bottom: 2rem;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
          }

          .stats-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 2rem;
            margin: 3rem 0;
          }

          .stat-card {
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            padding: 2rem;
            border-radius: 12px;
            text-align: center;
            border: 2px solid rgba(255,255,255,0.1);
            transition: all 0.3s ease;
          }

          .stat-card:hover {
            transform: translateY(-5px);
            border-color: rgba(255, 107, 53, 0.3);
            box-shadow: 0 12px 32px rgba(255, 107, 53, 0.1);
          }

          .stat-number {
            font-size: 3rem;
            font-weight: 800;
            color: #ff6b35;
            margin-bottom: 0.5rem;
          }

          .stat-label {
            font-size: 1.25rem;
            color: #fff;
            margin-bottom: 1rem;
            text-transform: uppercase;
            letter-spacing: 1px;
          }

          .features-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 2rem;
            margin-top: 2rem;
          }

          .feature-card {
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            padding: 2rem;
            border-radius: 12px;
            text-align: center;
            border: 2px solid rgba(255,255,255,0.1);
            transition: all 0.3s ease;
          }

          .feature-card:hover {
            transform: translateY(-5px);
            border-color: rgba(255, 107, 53, 0.3);
            box-shadow: 0 12px 32px rgba(255, 107, 53, 0.1);
          }

          .feature-icon {
            font-size: 2.5rem;
            margin-bottom: 1rem;
            color: #ff6b35;
          }

          .feature-card h3 {
            font-size: 1.5rem;
            color: #fff;
            margin-bottom: 1rem;
            text-transform: uppercase;
            letter-spacing: 1px;
          }

          .feature-card p {
            color: rgba(255,255,255,0.8);
            line-height: 1.6;
          }

          @media (max-width: 768px) {
            .hero-section h1 {
              font-size: 2.5rem;
            }

            .subtitle {
              font-size: 1.25rem;
            }

            .content-section {
              padding: 2rem 1rem;
            }

            .stats-grid,
            .features-grid {
              grid-template-columns: 1fr;
            }
          }
        `}
      </style>
    </div>
  );
};

export default About;